import { getSnapMenuLineItem } from 'containers/Snaps/Snap/lib';

import { OfferLineItemMatch } from 'codegen';

export const getFormattedMatchedOfferItem = (item: OfferLineItemMatch) => ({
  ...item,
  lineItem: {
    ...item.lineItem,
    ...getSnapMenuLineItem(item.lineItem),
    id: item.lineItem.id,
  },
  matchedOffer: {
    ...item.matchedOffer,
    id: item.matchedOffer?.id,
    value: item.matchedOffer?.id,
    label: item.matchedOffer?.rewardMiles ? `${item.matchedOffer?.rewardMiles} miles - ${item.matchedOffer?.offerName}` : item.matchedOffer?.offerName,
  },
}) as OfferLineItemMatch;
